<template>
  <v-row>
    <v-col cols="12" class="py-0" v-if="!isBlockEdition">
      <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu" :title="$t('general.journey')"/>
    </v-col>
    <template v-if="journeys.length === 0">
      <v-col class="d-flex justify-center align-center"
             :style="{ paddingTop: isBlockEdition ? '24px!important' : '50px!important' }"
             cols="12">
        <div style="width: 100%">
          <div class="pb-2 d-flex justify-center align-center">
            <v-icon :color="mainColor" size="40px" class="mr-2">mdi-sitemap</v-icon>
          </div>
          <span class="kbGray--text text-center d-block"
                style="font-size: 18px; margin: 0 auto"
                :style="{ maxWidth: $vuetify.breakpoint.smAndDown ? '100%' : '70%' }">
            {{ $t('general.noJourneyForCurrentApp') }}
          </span>
        </div>
      </v-col>
    </template>
    <template v-else-if="journeys.length > 0 && !isJourneyChangeConfirmationOpened">
      <v-col cols="12" class="px-0 text-center" :style="{ paddingTop: isBlockEdition ? '' : '50px' }">
        <span class="kbGray--text text-center d-block mb-4">
          {{ $t('general.changeJourneyCurrentStatus') }}
        </span>
        <div class="d-flex justify-center flex-wrap">
          <v-tooltip bottom
                     v-for="(journey, index) in journeys"
                     :key="`journey-${index}`">
            <template v-slot:activator="{ on }">
              <v-btn :color="journey.mainColor"
                     class="mx-2"
                     :disabled="setJourneyStatus(journey).isDisabled"
                     icon
                     v-on="on"
                     @click="showChangeJourneyConfirmation(journey)">
                <v-icon size="45px">
                  {{ setJourneyStatus(journey).icon }}
                </v-icon>
              </v-btn>
            </template>
            <v-row>
              <v-col cols="12" class="text-center pb-0">
                <v-icon :color="journey.mainColor"
                        class="mr-2">
                  mdi-radiobox-marked
                </v-icon>
                <span style="font-size: 18px">{{ journey.name }}</span>
              </v-col>
              <v-col cols="12"
                     :sm="Array.isArray(journey.dependencieOf) && journey.dependencieOf.length > 0 ? '6' : '12'"
                     v-if="Array.isArray(journey.dependsOn) && journey.dependsOn.length > 0">
                <span class="d-block text-center"
                      style="font-size: 14px">
                  {{ $t('general.dependsOn') }}
                </span>
                <ul class="pl-0 pt-1">
                  <li v-for="(dependency, index) in journey.dependsOn"
                      class="pb-1"
                      style="list-style: none"
                      :key="`dependsOn-${index}`">
                    <v-icon :color="getJourney(dependency).mainColor"
                            class="mr-2">
                      mdi-radiobox-marked
                    </v-icon>
                    <span>{{ getJourney(dependency).name }}</span>
                    <br>
                    <v-icon :color="getJourney(dependency).mainColor"
                            class="mr-2">
                      mdi-radiobox-marked
                    </v-icon>
                    <span>{{ 'ID: ' + getJourney(dependency).id }}</span>
                  </li>
                </ul>
              </v-col>
              <v-col cols="12"
                     :sm="Array.isArray(journey.dependsOn) && journey.dependsOn.length > 0 ? '6' : '12'"
                     v-if="Array.isArray(journey.dependencieOf) && journey.dependencieOf.length > 0">
                <span class="d-block text-center"
                      style="font-size: 14px">
                  {{ $t('general.isDependencyOf') }}
                </span>
                <ul class="pl-0 pt-1">
                  <li v-for="(dependency, index) in journey.dependencieOf"
                      class="pb-1"
                      style="list-style: none"
                      :key="`dependenciesOf-${index}`">
                    <v-icon :color="getJourney(dependency).mainColor"
                            class="mr-2">
                      mdi-radiobox-marked
                    </v-icon>
                    <span>{{ getJourney(dependency).name }}</span>
                    <br>
                    <v-icon :color="getJourney(dependency).mainColor"
                            class="mr-2">
                      mdi-radiobox-marked
                    </v-icon>
                    <span>{{ 'ID: ' + getJourney(dependency).id }}</span>
                  </li>
                </ul>
              </v-col>
            </v-row>
          </v-tooltip>
        </div>
      </v-col>
    </template>

    <template v-else-if="isJourneyChangeConfirmationOpened">
      <v-col cols="12" class="pb-0" style="padding-top: 50px">
        <span class="kbGray--text text-center d-block">
          {{ $t('general.changeJourneyCurrentStatusWarning') }}
        </span>
      </v-col>

      <v-col cols="12" class="d-flex justify-center align-center">
        <div class="align-self-stretch text-end" style="flex-basis: 45%">
          <v-icon :color="selectedUser.journey.mainColor"
                  class="mr-2"
                  size="35px">
            mdi-radiobox-marked
          </v-icon>
          <span class="text-capitalize kbDarkBlue--text"
                style="font-size: 18px">
            {{ selectedUser.journey.name }}
          </span>
        </div>

        <div class="d-flex align-center mx-4">
          <v-icon color="kbDarkBlue" size="35px">mdi-arrow-right</v-icon>
        </div>

        <div class="align-self-stretch text-start" style="flex-basis: 45%">
          <v-icon :color="selectedJourney.mainColor"
                  class="mr-2"
                  size="35px">
            mdi-radiobox-marked
          </v-icon>
          <span class="text-capitalize kbDarkBlue--text"
                style="font-size: 18px">
            {{ selectedJourney.name }}
          </span>
        </div>
      </v-col>

      <v-col cols="12" class="d-flex justify-center align-center pt-0">
        <v-tooltip class="ml-2" bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon
                   :color="mainColor"
                   class="mr-4"
                   dark
                   outlined
                   width="35px"
                   height="35px"
                   v-on="on"
                   @click="hideJourneyChangeComponent()">
              <v-icon size="40px">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('general.cancel') }}</span>
        </v-tooltip>

        <v-tooltip class="mr-2" bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon
                   :color="mainColor"
                   dark
                   v-on="on"
                   @click="changeActualJourney()">
              <v-icon size="40px">mdi-check-circle</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('general.changeJourneyStatus') }}</span>
        </v-tooltip>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
import journeyService from '@/services/journeyService.js'
export default {
  components: { ComponentsFixedBar },
  computed: {
    ...mapGetters(['companyUuid', 'appUuid']),
    ...mapState({
      selectedUser: state => state.users.selectedUser
    }),
    hasUserACurrentJourney () {
      return !(!this.selectedUser.journey ||
             typeof this.selectedUser.journey !== 'object' ||
             Object.keys(this.selectedUser.journey).length === 0)
    },
    currentJourneyPickableJourneys () {
      if (this.isBlockEdition) {
        if (!this.journeys || !Array.isArray(this.journeys)) return []
        return this.journeys
      } else {
        if (!this.selectedUser.journey.dependencieOf ||
          !Array.isArray(this.selectedUser.journey.dependencieOf)) return []
        return this.selectedUser.journey.dependencieOf
      }
    }
  },
  created () {
    this.getJourneys()
  },
  data () {
    return {
      journeys: [],
      isJourneyChangeConfirmationOpened: false,
      selectedJourney: {}
    }
  },
  methods: {
    async changeActualJourney () {
      const { userId } = this.selectedUser
      try {
        await this.$store.dispatch('updateUser', { userId, journeyId: this.selectedJourney.id })
        await this.$emit('getUser')
        this.hideJourneyChangeComponent()
      } catch (e) {
        this.hideJourneyChangeComponent()
        notifications.error(e.message)
        throw e
      }
    },
    changeDialogLoaderStatus (value) {
      this.$emit('changeDialogLoaderStatus', value)
    },
    async getJourneys () {
      try {
        const token = this.$store.getters.token
        const appUuid = this.$store.getters.appUuid
        const companyUuid = this.$store.getters.companyUuid
        const pagination = {
          itemsPerPage: 1000,
          page: 1
        }

        const response = await journeyService.getJourneys(token, companyUuid, appUuid, pagination)
        this.journeys = response.journeys.rows
      } catch (e) {
        notifications.error('Error obteniendo los journeys')
      }
    },
    hideJourneyChangeComponent () {
      this.selectedJourney = {}
      this.isJourneyChangeConfirmationOpened = false
    },
    getJourney (dependency) {
      const journey = this.journeys.find(item => item.id === dependency)
      return journey || {}
    },
    setJourneyStatus (journey) {
      const disabled = { icon: 'mdi-checkbox-blank-circle-outline', isDisabled: true }
      const pickable = { icon: 'mdi-checkbox-blank-circle-outline', isDisabled: false }
      const marked = { icon: 'mdi-radiobox-marked', isDisabled: false }
      if (this.isBlockEdition) {
        if (!this.selectedJourney.name || journey.name !== this.selectedJourney.name) return pickable
        else return marked
      }
      const foundPickableJourney = this.currentJourneyPickableJourneys.find(item => item.name === journey.name)
      if (!this.hasUserACurrentJourney || foundPickableJourney) return pickable
      else if (journey.name === this.selectedUser.journey.name) return marked
      else return disabled
    },
    showChangeJourneyConfirmation (journey) {
      if (this.isBlockEdition) {
        this.selectedJourney = journey
        this.$emit('onJourneyChange', this.selectedJourney.id)
        return
      }
      if (journey.name === this.selectedUser.journey.name) return
      this.selectedJourney = journey
      this.isJourneyChangeConfirmationOpened = true
    }
  },
  props: {
    isBlockEdition: {
      type: Boolean,
      default: false
    },
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    }
  }
}
</script>
